/* eslint-disable max-len */
import 'react';

const ExternalCopyWarnSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.40217 2C8.55687 -5.96046e-07 11.4436 7.15256e-07 12.5983 2L18.6605 12.5C19.8152 14.5 18.3718 17 16.0624 17H3.93807C1.62867 17 0.185293 14.5 1.33999 12.5L7.40217 2Z" fill="#FF7E73" />
        <path d="M10 10.625V5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 14C10.4142 14 10.75 13.6642 10.75 13.25C10.75 12.8358 10.4142 12.5 10 12.5C9.58579 12.5 9.25 12.8358 9.25 13.25C9.25 13.6642 9.58579 14 10 14Z" fill="white" />
    </svg>
);
export default ExternalCopyWarnSvg;

